import { GD } from "src/GD";

export class CampaignsService {
	constructor() {
		GD.REQ_CAMPAIGNS.listener = this.getCampaigns;
		GD.REQ_GET_CAMPAIGN.listener = this.getCampaign;
		GD.REQ_GET_CAMPAIGN_TEMPLATE.listener = this.getCampaignTemplate;
		GD.REQ_CREATE_CAMPAIGN.listener = this.createCampaign;
		GD.REQ_UPDATE_CAMPAIGN.listener = this.updateCampaign;
	}

	private getCampaigns: () => Promise<IAPIResponse<ICampaignSaved[]>> = async () => {
		const res = await GD.REQ_API.request({
			httpMethod: "GET",
			method: "campaigns/list",
		});

		return res as IAPIResponse<ICampaignSaved[]>;
	};

	private getCampaign: (id: string) => Promise<IAPIResponse<ICampaignSaved>> = async id => {
		const res = await GD.REQ_API.request({
			httpMethod: "GET",
			method: `campaigns/get?uid=${id}`,
		});
		return res as IAPIResponse<ICampaignSaved>;
	};

	private getCampaignTemplate: () => Promise<IAPIResponse<ICampaignRaw>> = async () => {
		const res = await GD.REQ_API.request({
			httpMethod: "GET",
			method: "campaigns/get?uid=-1",
		});
		return res as IAPIResponse<ICampaignRaw>;
	};

	private updateCampaign: (data: ICampaignSaved) => Promise<IAPIResponse<boolean>> = async data => {
		const res = await GD.REQ_API.request({
			method: "campaigns/update",
			httpMethod: "POST",
			data,
		});
		if ((res.data as any)?.error) return { data: false };
		if ((res.data as unknown as boolean) === true) return { data: true };
		return { error: { code: -1, message: "Unknown error" } };
	};

	private createCampaign: (data: ICampaignRaw) => Promise<IAPIResponse<ICampaignRaw>> = async data => {
		const res = await GD.REQ_API.request({
			method: "campaigns/register",
			httpMethod: "POST",
			data,
		});
		if ((res.data as any)?.error) return res.data as IAPIResponse<ICampaignRaw>;
		if (res.data && "uid" in (res.data as any)) return res.data as IAPIResponse<ICampaignRaw>;
		return { error: { code: -1, message: "Unknown error" } };
	};
}
